import ScrollIndicator from './modules/scrollindicator';
import Doughnut from './modules/doughnut';
import Utils from './utils';

import './vendors/scroll'; /* eslint-disable import/first */
import 'fullpage.js'; /* eslint-disable import/first */
import 'jquery-match-height'; /* eslint-disable import/first */

const Barba = require('barba.js');


export default class Dispatcher {
    constructor() {
        this.setDispatchers();
        this.clicked = false;
        this.scrollIndicator = new ScrollIndicator();
    }

    setDispatchers() {
        Barba.Dispatcher.on('linkClicked', this.linkClicked.bind(this));
        Barba.Dispatcher.on('initStateChange', this.initStateChange.bind(this));
        Barba.Dispatcher.on('newPageReady', this.onPageReady.bind(this));
    }

    linkClicked() {
        this.clicked = true;
    }

    initStateChange() {
        const fullPageWrapper = document.querySelector('.fullpage-wrapper');

        if (this.clicked === false) {
            if (fullPageWrapper) {
                fullPageWrapper.removeAttribute('style');
                fullPageWrapper.classList.remove('fp-destroyed');
                fullPageWrapper.classList.remove('fullpage-wrapper');
            }
        }

        this.clicked = false;

        if (typeof COMSCORE === 'function') {
            COMSCORE.beacon({ c1: '2', c2: '17689855', c4: location.pathname });
        }

        if (typeof ga === 'function') {
            ga('send', 'pageview', location.pathname);
        }
    }

    static hideComponent(container, className) {
        let $container = container;

        if (container instanceof jQuery === false) {
            $container = $(container);
        }

        return new Promise((resolve) => {
            $container.find(className).css('opacity', 0);
            resolve();
        });
    }

    onPageReady(current, prev, container) {
        if (current.namespace === 'home') {
            this.scrollIndicator.hide();
            return;
        }

        const that = this;
        const $container = $(container);
        const $col3 = $container.find('.excuse__col-3');
        const $col2 = $container.find('.excuse__col-2');

        if ($('html').hasClass('fp-enabled')) {
            $.fn.fullpage.destroy('all');
        }

        if ($(window).width() >= 767) {
            $col3.matchHeight();
            $col2.matchHeight();
        }

        if (Utils.isMobile()) {
            return;
        }

        Promise
            .all([
                this.constructor.hideComponent($container, '.excuse__quote-box'),
                this.constructor.hideComponent($container, '.excuse__video-container'),
                this.constructor.hideComponent($container, '.excuse__custom_points'),
                this.constructor.hideComponent($container, '.excuse__chart-container'),
                this.constructor.hideComponent($container, '.excuse__chart-small-note'),
            ])
            .then(() => {
                $container.fullpage({
                    bigSectionDestination: 'top',
                    navigation: true,
                    navigationPosition: 'right',
                    responsiveWidth: 1000,
                    responsiveHeight: 500,
                    scrollOverflow: true,
                    showActiveToolTip: true,
                    afterResize() {
                        // TODO(jooi): Duplicate clean up later.
                        if ($(window).width() >= 767) {
                            $col3.matchHeight();
                            $col2.matchHeight();
                            return;
                        }

                        $col2.css('height', '');
                        $col3.css('height', '');
                    },
                    afterRender() {
                        that.scrollIndicator.show();
                        $container.find('.excuse__quote-box').animateCss('aniQuoteBox');
                        $container.find('.excuse__video-container').animateCss('aniVideoContainer');
                        $container.find('.excuse__custom_points').animateCss('aniCustomPoints');
                        $container
                            .find('.excuse__chart-container')
                            .animateCss('aniChartContainer', () => {
                                try {
                                    new Doughnut();
                                } catch (err) {
                                    console.log(`Doughnut: ${err}`);
                                }
                            });
                        $container.find('.excuse__chart-small-note').animateCss('aniChartSmallNote');
                    },
                    afterResponsive(isResponsive) {
                        if (isResponsive) {
                            $('.footer').css('position', 'relative');
                        } else {
                            $('.footer').css('position', '');
                        }
                    },
                    afterLoad(anchorLink, index) {
                        if (index === 1) {
                            that.scrollIndicator.show();
                        } else if (index === 2) {
                            that.scrollIndicator.hide();
                        }
                    },
                });
            });
    }
}



// WEBPACK FOOTER //
// ./frontend/js/dispatcher.js